module.exports = __webpack_public_path__ + "../resources/images/EditorUpsell-0f681fbff6a93db2b22ebeed8d01405e.svg";